module.exports = __webpack_public_path__ + "static/face-tracking-for-homepage-d56140d3091fac3b957495b23e585b68.jpg";